import _ from 'lodash';

import FileCMSModel from '@/visa-application/models/FileCMSModel';
import CMSModel from '@/visa-application/models/CMSModel';

export default class AddedValueServiceCMSModel implements CMSModel {
  sku = '';
  image_url = '';
  image: FileCMSModel = new FileCMSModel();
  status = '';
  name = '';
  short_description = '';
  long_description = '';
  allGroupMembers = false;
  video_url = '';
  more_info_url = '';

  map(obj: any): void {
    this.sku = _.get(obj, 'sku', '');
    this.image_url = _.get(obj, 'image_url', '');
    this.image.map(_.get(obj, 'image', undefined));
    this.status = _.get(obj, 'status', '');
    this.name = _.get(obj, 'translation[0].name', '');
    this.short_description = _.get(obj, 'translation[0].short_description', '');
    this.long_description = _.get(obj, 'translation[0].long_description', '');
    this.allGroupMembers = _.get(obj, 'all_group_members', false);
    this.video_url = _.get(obj, 'translation[0].video_url', '');
    this.more_info_url = _.get(obj, 'more_info_url', '');
  }
}
